<script>
import CardUpdateCRM from '@/views/Scenario/StepEditor/Card/CardUpdateCRM.vue'

export default {
    name: 'CardUpdateCRM',
    extends: CardUpdateCRM,
    mounted () {
        console.log(this.card.config)
    },
    computed: {
        variableList () {
            return this.card.config.update_attribute.map(o => {
                return {
                    name: o.get_variable
                }
            })
        }
    },
    methods: {
        getItemList (idx) {
            return this.card.config.update_attribute.map(o => {
                return {
                    text: o.crm_col_attribute,
                    value: o.crm_col_attribute
                }
            })
        }
    }
}
</script>
